import { render, staticRenderFns } from "./DescriptionOrLink.vue?vue&type=template&id=e699e7b4&"
import script from "./DescriptionOrLink.vue?vue&type=script&lang=js&"
export * from "./DescriptionOrLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports